import React, { useState, useEffect, useRef } from 'react'

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useReactToPrint } from 'react-to-print';

import { Table, Tooltip,Tag,Form, Input, Button, Space,Modal,Descriptions,Divider,
  Statistic, Col,Popconfirm,Collapse,Select,DatePicker, List,InputNumber,
  TimePicker,Checkbox, message} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined,
    EditOutlined,
    PlusOutlined,
    SaveOutlined,
    ShoppingCartOutlined,
    DeleteOutlined
} from '@ant-design/icons';

import './styles.scss'

import moment from 'moment'
import {getData,editItem,addItem,deleteItem,updateItem} from '../../../Redux/actions/crudActions'
import {setPrice} from '../../../Redux/actions/productActions'
import {addCartItem,getCart,deleteCartItem,editCartItem,clearCart} from '../../../Redux/actions/cartActions'
import {createPackage,getPackageData,setPackage} from '../../../Redux/actions/packageActions'

import {errorParser,camelToSentence} from '../../../utils/helpers'

import CreateForm from '../../Generic/CreateForm'
import InputSelect from '../../Generic/InputSelect'
import ImageChecker from '../../Generic/ImageChecker'
import QRCode from "react-qr-code";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({currentItem,showID}) => { 
    
    const dispatch = useDispatch()    
    const { user,cart,locations } = useSelector(state => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations 
    }), shallowEqual)


    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [modalWidth, setmodalWidth] = useState('80%')
    const [loading, setLoading] = useState(false)

    const [destination, setDestination] = useState(null)
    const [destinationName, setDestinationName] = useState(null)
    const [packItems, setPackItems] = useState([])

    const [shippingFee, setShippingFee] = useState(0)




    useEffect(() => {
      if(currentItem.shipping_fee){
   
        setShippingFee(currentItem.shipping_fee)
      }
      
    },[currentItem]);

    const savenewShippingFee  = () =>{
      setLoading(true)
      var packdata  ={
        shipping_fee:shippingFee
      } 
      dispatch(setPackage(packdata,currentItem.id))
      .then(res=>{
        message.success('shipping fee updated')
        setLoading(false)     
      })
      .catch(err=>{
        setLoading(false)     
      })
      
    }

    const BasicInfo = () =>{
      var dest = locations.filter(i =>i.id == currentItem.destination)
      var destData = dest[0]

      return(
        <div className={'orderDetail1'}>
        <div className={'firspart'}>
          {showID ? 
          <div className={'desc'}>
            <span className={'label'}>Order Id:</span> <span className={'val'}> {currentItem.id} </span>
          </div>
          :null}
          <div className={'desc'}>
            <span className={'label'}>Destination: </span> <span className={'val'}>{destData.name}</span>
          </div>
          <div className={'desc'}>
            <span className={'label'}>Contact Person: </span> <span className={'val'}>{destData.contact_person}</span>
          </div>
          <div className={'desc'}>
            <span className={'label'}>Contact No: </span> <span className={'val'}>{destData.contactno}</span>
          </div > 
          <div className={'desc'}> 
            <span className={'label'}>Address: </span> <span className={'val'}>{destData.address}</span>
          </div>
                        
  
        </div>
          <div className={'qtypart'}>
            <span>Status</span>
            <h3>{camelToSentence(currentItem.status)}</h3>
            <span>Items</span>
            <h1>
            {currentItem.items.length}
            </h1>
          </div>
        </div>
      )

    }




    const ShippingInfo = () =>{
      if(currentItem && (currentItem.status == 'shipping' || currentItem.status == 'completed') ){
      return(
   
        <div className={'orderTitleCard'}>
            
            <div className={'firspart'}>
              <div className={'desc'}>
                <span className={'label'}>Courrier:</span> <span className={'val'}> {currentItem.shipping_method_name} </span>
              </div>
              <div className={'desc'}>
                <span className={'label'}>Driver: </span> <span className={'val'}>{currentItem.shipping_driver}</span>
              </div>
              <div className={'desc'}>
                <span className={'label'}>Driver Phone: </span> <span className={'val'}>{currentItem.shipping_contact}</span>
              </div >
              <div className={'desc'}>
                <span className={'label'}>Plate no: </span> <span className={'val'}>{currentItem.shipping_plate}</span>
              </div>
              <div className={'desc'}> 
                <span className={'label'}>Tracking: </span><a href={currentItem.shipping_url} target="_blank" className={'val'}>Click Here</a>
              </div> 
            </div> 
            <div className={'qtypart'}>
                <span>Shipping Fee</span>
                {user && (( user.role == 'admin' ||  user.role == 'warehouse' || user.role == 'manager')   ||  ( currentItem.is_direct&& user.role == 'oic')) ?
                  <div className={'horizontal'}>
                    <InputNumber  prefix="₱" value={shippingFee}  onChange={e=>{setShippingFee(e)}}/>
                    <Button onClick={()=>{savenewShippingFee()}} loading={loading} disabled={shippingFee == currentItem.shippingFee } type="primary"><SaveOutlined /></Button>
                  </div>
                :
                  <h1>
                    {currentItem.shipping_fee}
                  </h1>
                }
       
              </div>
        </div>
   
    
      )
      }
    }

    return(  
      <div>     
      {BasicInfo()}
      {ShippingInfo()}
      </div>
    )
}
  
export default Index
  